import Application from '../../Application'
import utils from '../../utils'
import ScorocodeError from '../../utils/ScorocodeError'
import { IQuery } from '../client/PGManager'
import Document from './Document'
import DocumentList from './DocumentList'

export const ORDER_ASC = 'ascend'
export const ORDER_DESC = 'descend'

export const DEFAULT_LIMIT = 20

export default class Query {
  private _from?: number
  private _limit: number
  private readonly _filter: string[]
  private readonly _order: string[]

  constructor(
    public readonly app: Application,
    public readonly db: string,
    public readonly schema: string,
    public readonly collection: string
  ) {
    this._limit = (app.config.db && app.config.db.defaultLimit) || DEFAULT_LIMIT
    this._filter = []
    this._order = []
  }

  sync(): Promise<DocumentList> {
    const dbQueryParams: IQuery = {
      calc_total: 1,
    }

    // if (this._limit !== undefined) {
    dbQueryParams.limit = this._limit
    // }

    if (this._from !== undefined) {
      dbQueryParams.from = this._from
    }

    if (this._order.length) {
      dbQueryParams.order = this._order
    }

    if (this._filter.length) {
      dbQueryParams.filter = this._filter
    }

    return this.app
      .client()
      .pg.getDocumentList(this.db, this.schema, this.collection, dbQueryParams)
      .then((response) => {
        const items = response.items.map((document) =>
          new Document(
            this.app,
            this.schema,
            this.collection,
            document.id
          ).setAttributes(document)
        )

        return new DocumentList(
          this._from || 0,
          this._limit || items.length,
          response.total,
          items
        )
      })
  }

  // must return unsubscribe function
  realSync(
    onSuccess: (list: DocumentList) => {},
    onError: (error: ScorocodeError) => {}
  ) {
    // todo implementation
    this.sync()
      .then((list) => onSuccess(list))
      .catch()
  }

  count(): Promise<number> {
    const dbQueryParams: IQuery = {
      from: 0,
      limit: 0,
      calc_total: 1,
    }

    if (this._order.length) {
      dbQueryParams.order = this._order
    }

    if (this._filter.length) {
      dbQueryParams.filter = this._filter
    }

    return this.app
      .client()
      .pg.getDocumentList(this.db, this.schema, this.collection, dbQueryParams)
      .then((response) => response.total)
  }

  from(from: number): this {
    this._from = from

    return this
  }

  limit(limit: number): this {
    this._limit = limit

    return this
  }

  orderBy(field: string, dir: string): this {
    if (dir === ORDER_ASC) {
      this._order.push(`${field}+`)
    } else if (dir === ORDER_DESC) {
      this._order.push(`${field}-`)
    }

    return this
  }

  filterBy(fieldOrFilterObject: {} | string, value?: any): this {
    let filterBy: {} = {}

    if (value === undefined && typeof fieldOrFilterObject === 'string') {
      filterBy[fieldOrFilterObject] = value
    } else if (typeof fieldOrFilterObject === 'object') {
      filterBy = fieldOrFilterObject
    } else {
      utils.throwError(
        'PG.Query.FilterBy.BadParams',
        `Query::filterBy - received bad params`
      )
    }

    const toFilterFields = Object.entries(filterBy)

    toFilterFields.map(([name, val]) => this._filter.push(`${name}:${val}`))

    return this
  }

  page(page: number): this {
    return this.from(Math.max(Math.floor(page) - 1, 0) * this._limit)
  }
}
